import { Step1, type Step1Data } from './step1'
import { Step2, type Step2Data } from './step2'
import { Step3, type Step3Data } from './step3'
import { Step4, type Step4Data } from './step4'

export type AllStepsData = Step1Data & Step2Data & Step3Data & Step4Data

export const steps = [
  <Step1 key="experienced1" />,
  <Step2 key="experienced2" />,
  <Step3 key="experienced3" />,
  <Step4 key="experienced4" />,
]
